module.exports = __webpack_public_path__ + "b1a9878ceaaffd6690a1a33aaae4d42d.png";